import { render, staticRenderFns } from "./SelectAttributes.vue?vue&type=template&id=24d69bba&scoped=true&"
import script from "./SelectAttributes.vue?vue&type=script&lang=js&"
export * from "./SelectAttributes.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=24d69bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d69bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d69bba')) {
      api.createRecord('24d69bba', component.options)
    } else {
      api.reload('24d69bba', component.options)
    }
    module.hot.accept("./SelectAttributes.vue?vue&type=template&id=24d69bba&scoped=true&", function () {
      api.rerender('24d69bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectAttributes.vue"
export default component.exports